import React, { useEffect } from 'react';
import './croqly.css';
import Header from './Header';
import { Link } from 'react-router-dom';

const Croqly = () => {
  // Testimonials data
  const testimonials = [
    {
      id: 1,
      username: "sarah crochet",
      comment: "I'm amazed! I've completed 17 projects with Croqly's pattern system - it's so easy to follow and track my progress! 🧶✨"
    },
    {
      id: 2,
      username: "maya yarns",
      comment: "I'VE BEEN USING CROQLY FOR A YEAR STRAIGHT - MY STASH IS PERFECTLY ORGANIZED AND I NEVER LOSE PATTERNS ANYMORE! 🟧❤️"
    },
    {
      id: 3,
      username: "emma stitches",
      comment: "I love your app! It helps me keep track of my crochet projects without overthinking everything and gives me a visual of my progress plus it's so aesthetic ⭐"
    }
  ];

  // Scroll animation effect
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);

    // Observe all elements with scroll-animate class
    const animateElements = document.querySelectorAll('.scroll-animate');
    animateElements.forEach((el) => observer.observe(el));

    return () => {
      animateElements.forEach((el) => observer.unobserve(el));
    };
  }, []);
  return (
    <div>
      <div className="floating-elements">
        <div className="floating-element"></div>
        <div className="floating-element"></div>
        <div className="floating-element"></div>
      </div>

      <Header />

      <main>
        <section className="hero scroll-animate">
          <div className="container">
            <div className="hero-content">
              <div className="hero-text">
                <h1 className="hero-title">Unlock Your Creativity with Croqly.</h1>
                <p className="hero-subtitle">
                  Join thousands of happy crafters who use Croqly to simplify their creative process. Get organized,
                  stay inspired, and focus on what you love – creating beautiful things.
                </p>
                <a
                  className="app-store-badge"
                  href="https://apps.apple.com/ma/app/croqly-crochet-knitting/id6753090359"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Download Croqly on the App Store"
                >
                  <img src="appstore.png" alt="Download on the App Store" />
                </a>
              </div>
              <div className="screenshot-container">
                <div className="animated-showcase">
                  <div className="phone-mockup phone-1">
                    <img src="hometa.png" alt="Smart Pattern System" className="mockup-image" />
                  </div>
                  <div className="phone-mockup phone-2">
                    <img src="trackta.png" alt="Project Tracking" className="mockup-image" />
                  </div>
                  <div className="phone-mockup phone-3">
                    <img src="stashta.png" alt="Stash Organizer" className="mockup-image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="features scroll-animate">
          <div className="container">
           
            <FeatureSection 
              title="Smart Pattern System"
              description="Transform any PDF or website crochet pattern into an interactive, step-by-step guide. Our intelligent system automatically detects rows, stitches, and progress markers, making complex patterns easy to follow. Never lose your place again with built-in row tracking, stitch counting, and visual progress indicators that adapt to your working style."
              imageSrc="hometa.png"
              imageAlt="Smart Pattern Screenshot"
            />
                   
            <FeatureSection 
              title="Project Tracking"
              description="Keep detailed records of every crochet project with comprehensive tracking features. Monitor your progress with time logging, yarn consumption tracking, and completion percentages. Set project goals, track milestones, and maintain a complete history of your creative journey. Perfect for managing multiple projects simultaneously and staying organized with your crochet endeavors."
              imageSrc="trackta.png"
              imageAlt="Project Tracking Screenshot"
              reverse={true}
            />
            
            <FeatureSection 
              title="Stash Organizer"
              description="Organize and catalog your entire crochet collection with our comprehensive stash management system. Track yarn colors, weights, fiber content, and quantities with detailed photos and notes. Manage your hooks, needles, and accessories with custom categories and search functionality. Never wonder what you have in your stash again - find the perfect yarn for any project instantly."
              imageSrc="stashta.png"
              imageAlt="Stash Tracking Screenshot"
            />
            
            <FeatureSection 
              title="Helpful Tools"
              description="Access a complete suite of crochet tools and calculators designed to make your projects easier and more accurate. Calculate yarn requirements, convert between measurement units, count rows and stitches, and generate beautiful color palettes. Includes gauge calculators, stitch pattern generators, and project planning tools - everything you need to succeed in your crochet journey."
              imageSrc="toolsta.png"
              imageAlt="Tools Screenshot"
              reverse={true}
            />
            
            <FeatureSection 
              title="Discover Patterns"
              description="Explore an extensive library of curated crochet patterns from beginner-friendly projects to advanced masterpieces. Browse by difficulty level, yarn weight, project type, and style preferences. Discover trending patterns, seasonal collections, and community favorites. Save patterns to your personal library, rate and review projects, and get inspired by the endless possibilities of crochet creativity."
              imageSrc="discoverta.png"
              imageAlt="Discover Patterns Screenshot"
            />
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="testimonials-section scroll-animate">
          <div className="container">
            <div className="testimonials-header">
              <h2>Thousands of users talk about us</h2>
            </div>
            <div className="testimonials-grid">
              {testimonials.map((testimonial) => (
                <div key={testimonial.id} className="testimonial-card dark-testimonial-card scroll-animate">
                  <div className="testimonial-header">
                    <div className="user-avatar">
                      {testimonial.username.charAt(0).toUpperCase()}
                    </div>
                    <div className="user-info">
                      <h4 className="username">@{testimonial.username}</h4>
                    </div>
                  </div>
                  <p className="testimonial-comment">{testimonial.comment}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

// Composant pour les sections de fonctionnalités
const FeatureSection = ({ title, description, imageSrc, imageAlt, reverse = false }) => {
  return (
    <div className={`feature-section scroll-animate ${reverse ? 'reverse' : ''}`}>
      <div className="feature-text">
        <h2 className="feature-title">{title}</h2>
        <p className="feature-desc">{description}</p>
      </div>
      <div className="screenshot-container">
        <img src={imageSrc} alt={imageAlt} className="screenshot" />
      </div>
    </div>
  );
};

// Composant Footer séparé
const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <div className="footer-content">
                      <div className="footer-links">
                        <Link to="/">Home</Link>
                        <Link to="/terms">Terms of Service</Link>
                        <Link to="/privacy">Privacy Policy</Link>
                        <Link to="/contact">Contact</Link>
                      </div>
                      </div>
          <div className="social-links">
            <a href="https://tiktok.com/@croqly.app" className="social-link" aria-label="TikTok">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                <path
                  d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"
                />
              </svg>
            </a>
            <a href="mailto:itarnaevents2@gmail.com" className="social-link" aria-label="Email">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                <path
                  d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                />
              </svg>
            </a>
          </div>

          <div className="copyright">
            © 2025 Croqly. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Croqly;